import { SVGProps } from "react"

const BreadcrumbsSlashIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M4.35511 0.863636L1.54261 11.3125H0.191761L3.00426 0.863636H4.35511Z" fill="#111827" />
    </svg>
)

export default BreadcrumbsSlashIcon
